// extracted by mini-css-extract-plugin
module.exports = {"title":"StoreSearch_title__11hmy","section":"StoreSearch_section__3gnlO","store":"StoreSearch_store__ZOehg","mobile":"StoreSearch_mobile__27OsX","main":"StoreSearch_main__3_99F"};